import { z } from 'zod'
import { Pagination } from '../helper'

export const reportIntervalEnum = z.enum(['Daily', 'Weekly', 'Monthly'])

export const reportDeviceIndicatorSchema = z.object({
  id: z.string(),
  indicatorCode: z.string().nullable(),
  orderNo: z.number(),
})

export const reportDeviceSchema = z.object({
  id: z.string(),
  deviceId: z.string(),
  orderNo: z.number(),
  indicators: z.array(reportDeviceIndicatorSchema).nullable(),
})

export const reportRecipientSchema = z.object({
  id: z.string(),
  email: z.string().nullable(),
})

export const reportListItemSchema = z.object({
  id: z.string(),
  name: z.string().nullable(),
  description: z.string().nullable(),
  templateId: z.string(),
  templateName: z.string().nullable(),
  language: z.string().nullable(),
  interval: z.string().nullable(),
  isEnabled: z.boolean(),
  deviceCount: z.number(),
  recipientCount: z.number(),
  createdAt: z.string(),
})

export const reportDetailsSchema = z.object({
  id: z.string(),
  name: z.string().nullable(),
  description: z.string().nullable(),
  templateId: z.string(),
  templateName: z.string().nullable(),
  language: z.string().nullable(),
  interval: z.string().nullable(),
  startDay: z.number().nullable(),
  generationHourUtc: z.number(),
  isEnabled: z.boolean(),
  createdAt: z.string(),
  createdBy: z.string(),
  lastModifiedAt: z.string().nullable(),
  lastModifiedBy: z.string().nullable(),
  devices: z.array(reportDeviceSchema).nullable(),
  recipients: z.array(reportRecipientSchema).nullable(),
})

export type TReportInterval = z.infer<typeof reportIntervalEnum>
export type TReportDeviceIndicator = z.infer<typeof reportDeviceIndicatorSchema>
export type TReportDevice = z.infer<typeof reportDeviceSchema>
export type TReportRecipient = z.infer<typeof reportRecipientSchema>
export type TReportListItem = z.infer<typeof reportListItemSchema>
export type TReportDetails = z.infer<typeof reportDetailsSchema>
export type TReportList = Pagination<TReportListItem>
